import { createModuleContext } from '@rebuild/utils/moduleContext';

const MODULE_NAME = 'flow_history_nav';

function buildBaseCtx() {
	return {
		formattedNavTitle: nav => nav.name
	};
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

export { provideCurrentContext, useCurrentContext };
